import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
    SAPPassportHeader,
    SAPPassport,
    SAPLoadState,
    SAPPassportFormState,
    SAPStory,
    SAPPassportID,
    SAPPassportHeaderDefault,
    SAPPassportForm,
    SAPPassportFormDefault,
} from "userful-chronos-app-common-js/dist/models/integration/sap";
import {
    requestListPassports,
    requestAddPassport,
    requestUpdatePassport,
    requestRemovePassport,
    requestUpdatePassportWithOAuth,
    requestListStory,
} from "./msgs/sapMsgSender";

const initialState: {
    sapPassports: SAPPassport[];
    loadState: SAPLoadState;
    passport: SAPPassportForm;
    copyPassport: SAPPassportForm;
    formType: SAPPassportFormState;
    openForm: boolean;
    authCode: string;
    listStory: SAPStory[];
} = {
    sapPassports: [],
    loadState: "RENDER",
    passport: SAPPassportFormDefault(),
    copyPassport: SAPPassportFormDefault(),
    formType: "Create",
    openForm: false,
    authCode: "",
    listStory: [],
};

export const sapSlice = createSlice({
    name: "sapSlice",
    initialState,
    reducers: {
        setPassports: (state, action: PayloadAction<SAPPassport[]>) => {
            state.sapPassports = action.payload;
        },
        addOrUpdatePassport: (state, action: PayloadAction<SAPPassport>) => {
            const foundIndex = state.sapPassports.findIndex((item) => item.id.value === action.payload.id.value);
            if (foundIndex < 0) {
                state.sapPassports = [...state.sapPassports, { ...action.payload }];
            } else {
                state.sapPassports = [
                    ...state.sapPassports.slice(0, foundIndex),
                    { ...action.payload },
                    ...state.sapPassports.slice(foundIndex + 1),
                ];
            }
        },
        removePassport: (state, action: PayloadAction<SAPPassportID>) => {
            state.sapPassports = state.sapPassports.filter((item) => item.id.value !== action.payload.value);
        },
        getPassportsFromServer: (state, action: PayloadAction<{}>) => {
            requestListPassports();
        },
        addPassportToServer: (state, action: PayloadAction<SAPPassportHeader>) => {
            requestAddPassport(action.payload);
        },
        updatePassportToServerWithOAuth: (state, action: PayloadAction<SAPPassportHeader>) => {
            requestUpdatePassportWithOAuth(action.payload);
        },
        updatePassportToServer: (state, action: PayloadAction<SAPPassportHeader>) => {
            requestUpdatePassport(action.payload);
        },
        removePassportToServer: (state, action: PayloadAction<SAPPassportID>) => {
            requestRemovePassport(action.payload);
        },
        changeLoadState: (state, action: PayloadAction<SAPLoadState>) => {
            state.loadState = action.payload;
        },
        setPassport: (state, action: PayloadAction<SAPPassportForm>) => {
            state.passport = action.payload;
        },
        setCopyPassport: (state, action: PayloadAction<SAPPassportForm>) => {
            state.copyPassport = action.payload;
        },
        setFormType: (state, action: PayloadAction<SAPPassportFormState>) => {
            state.formType = action.payload;
        },
        setOpenForm: (state, action: PayloadAction<boolean>) => {
            state.openForm = action.payload;
        },
        setAuthCode: (state, action: PayloadAction<string>) => {
            state.authCode = action.payload;
        },
        requestListStory: (state, action: PayloadAction<SAPPassportID>) => {
            requestListStory(action.payload);
        },
        setListStory: (state, action: PayloadAction<SAPStory[]>) => {
            state.listStory = action.payload;
        },
    },
});

export const sapActions = sapSlice.actions;

export default sapSlice.reducer;
